import { Company } from 'module/api/company/types';
import { AccountPeopleProfile } from 'api/account-people/profile-type';
import styled from 'styled-components';
import { BasicInformation } from './basic-information';
import { Education } from './education';
import { Experience } from './experience';
import { IceBreakers } from './ice-breaker';
import { LastEngagement } from './last-engagement';
import { LikesAndInterests } from './likes-interests';
import { MoreFields } from './more-fields';
import { PriorityFields } from './priority-fields';

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: var(--spacing-07);
  padding-bottom: var(--spacing-08);
`;

interface Props {
  userProfile: AccountPeopleProfile;
  company: Company;
}
export const UserInformation = ({ userProfile, company }: Props) => {
  return (
    <Wrapper>
      <BasicInformation userProfile={userProfile} company={company} />
      <PriorityFields userProfile={userProfile} />
      <LastEngagement userProfile={userProfile} />
      <IceBreakers userProfile={userProfile} />
      <LikesAndInterests userProfile={userProfile} />
      <MoreFields userProfile={userProfile} />
      <Experience userProfile={userProfile} />
      <Education userProfile={userProfile} />
    </Wrapper>
  );
};
